const addressCache = new Map();

export async function getAddressFromCoordinates(lat, lon) {
    if (!lat || !lon || isNaN(lat) || isNaN(lon)) return "Coordonnées invalides";

    const key = `${lat.toFixed(4)},${lon.toFixed(4)}`;
    if (addressCache.has(key)) {
        return addressCache.get(key);
    }
    
    try {
        const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lon}`, {
            headers: { 'Accept': 'application/json' }
        });
        
        if (!response.ok) return "Service d'adresse indisponible";
        
        const data = await response.json();
        const fullAddr = data.display_name;
        // Priorité à un format court et lisible (rue + ville) si disponible
        let formatted = fullAddr;
        if (data.address) {
            const road = data.address.road || data.address.pedestrian || data.address.suburb || "";
            const city = data.address.city || data.address.town || data.address.village || data.address.municipality || "";
            if (road && city) {
                formatted = `${road}, ${city}`;
            } else if (city) {
                formatted = city;
            }
        }
        const finalAddress = formatted || fullAddr || "Adresse non trouvée";
        addressCache.set(key, finalAddress);
        return finalAddress;
    } catch (error) {
        console.warn("[GEO] Erreur réseau sur Nominatim");
        return "Localisation en cours...";
    }
}